import type { ReactElement } from "react";
import { severityMeta, type SeverityGlyph } from "../../lib/bobConsole";

const GLYPHS: Record<SeverityGlyph, ReactElement> = {
  octagon: <path d="M8 2h8l6 6v8l-6 6H8l-6-6V8z" />,
  triangle: <path d="M12 3 23 21H1z" />,
  circle: <circle cx="12" cy="12" r="9" />,
};

export function SeverityGlyph({ severity, size = 11 }: { severity: unknown; size?: number }) {
  const meta = severityMeta(severity);
  if (!meta) return null;
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">{GLYPHS[meta.glyph]}</svg>;
}

/** A severity as a glyph and a word, so colour never carries it alone. */
export default function SeverityChip({ severity }: { severity: unknown }) {
  const meta = severityMeta(severity);
  const label = typeof severity === "string" ? severity : "";
  return (
    <span className={`bob-chip bob-sev bob-sev-${meta ? meta.key.toLowerCase() : "other"}`} data-sev={label}>
      <SeverityGlyph severity={severity} />
      {label}
    </span>
  );
}
